import Icon from '../components/Icon.vue'

Icon.register({"ring":{"width":512,"height":512,"paths":[{"d":"M256 64C110.1 64 0 125.9 0 208V306.1C0 384.5 114.6 448 256 448S512 384.5 512 306.1V208C512 125.9 401.9 64 256 64zM256 128C362 128 448 163.8 448 208 448 217.3 444 226.1 437.1 234.4 392.1 208.2 328.2 192 256 192S119.8 208.2 74.9 234.4C68 226.1 64 217.3 64 208 64 163.8 150 128 256 128zM120.4 264.6C155 249.9 201.6 240 256 240S357 249.9 391.6 264.6C356.8 279.1 308.9 288 256 288S155.2 279.1 120.4 264.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/ring.js
// module id = null
// module chunks = 